import React from 'react';
import ReactDOM from 'react-dom/client';
import OfflineApp from './offline-app.jsx';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<OfflineApp />);
